export const datePickerFormat = {
  dateInput: 'MM/DD/YYYY',
  displayDate: 'MM/DD/YYYY',
  monthYearLabel: 'MM/DD/YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
